import React from 'react';
import {Modal, ScrollView, Text, TouchableOpacity, View} from 'react-native';
import Feather from 'react-native-vector-icons/Feather';
import ButtonComponent from '../../../../components/ButtonComponent/ButtonComponent';
import {Colors} from '../../../../constants/Colors';
import {styles} from './styles';
import LinearProgress from '../LinearProgress/LinearProgress';
import CircularProgress from '../../../Campaigns/components/CircleGraphic/CircularProgress';
import DropDownFilter from '../../../Home/components/DropDownFilter/DropDownFilter';
import DropDownMenu from '../../../Home/components/DropDownMenu/DropDownMenu';

interface IIndicatorDetails {
  visible: boolean;
  onRequestClose: () => void;
  onPress: () => void;
}

const IndicatorDetails = ({
  visible,
  onRequestClose,
  onPress,
}: IIndicatorDetails) => {
  return (
    <Modal
      animationType="slide"
      transparent={true}
      visible={visible}
      onRequestClose={onRequestClose}>
      <View style={styles.containerModal}>
        <View style={styles.containerFilter}>
          <ScrollView>
            <View style={styles.spaceHorizontal}>
              <TouchableOpacity onPress={onRequestClose}>
                <Feather
                  name="x"
                  size={32}
                  color={Colors.lightGray}
                  style={styles.iconX}
                />
              </TouchableOpacity>
              <Text style={styles.filterText}>Detalhes do indicador</Text>
            </View>
            <Text
              style={{
                fontSize: 12,
                lineHeight: 14,
                color: 'black',
                fontFamily: 'TCCC-UnityText Bold',
                alignSelf: 'center',
                marginTop: 60,
              }}>
              Teste de cobertura indicador
            </Text>
            <Text
              style={{
                fontSize: 12,
                lineHeight: 14,
                color: Colors.GrayPallete.lightgrayThree,
                fontFamily: 'TCCC-UnityHeadline Regular',
                alignSelf: 'center',
                textAlign: 'center',
                maxWidth: 200,
                marginTop: 20,
              }}>
              Período de apuração:{' '}
              <Text
                style={{
                  fontFamily: 'TCCC-UnityText Bold',
                }}>
                25/10/2023 - 25/10/2024
              </Text>
            </Text>
            <View
              style={{
                paddingHorizontal: 10,
              }}>
              <View
                style={{
                  width: '100%',
                  alignItems: 'center',
                  marginTop: 30,
                  borderBottomWidth: 1,
                  borderColor: Colors.GrayPallete.lightgrayTwo,
                  paddingBottom: 30,
                }}>
                <LinearProgress />
                <View
                  style={{
                    marginTop: 70,
                  }}>
                  <CircularProgress />
                </View>
              </View>
              <Text
                style={{
                  fontSize: 12,
                  lineHeight: 14,
                  color: 'black',
                  fontFamily: 'TCCC-UnityText Bold',
                  alignSelf: 'flex-start',
                  marginTop: 20,
                }}>
                Descrição
              </Text>
              <Text
                style={{
                  fontSize: 12,
                  lineHeight: 14,
                  color: Colors.GrayPallete.lightgrayThree,
                  fontFamily: 'TCCC-UnityHeadline Regular',
                  alignSelf: 'flex-start',
                  textAlign: 'center',
                  maxWidth: 200,
                  marginTop: 15,
                }}>
                Teste de cobertura
              </Text>
              <View
                style={{
                  flexDirection: 'row',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                }}>
                <Text
                  style={{
                    fontSize: 12,
                    lineHeight: 14,
                    color: 'black',
                    fontFamily: 'TCCC-UnityText Bold',
                    alignSelf: 'center',
                    marginTop: 60,
                  }}>
                  Pontos
                </Text>
                <Text
                  style={{
                    fontSize: 12,
                    lineHeight: 14,
                    color: 'black',
                    fontFamily: 'TCCC-UnityText Bold',
                    alignSelf: 'center',
                    marginTop: 60,
                  }}>
                  0/30
                </Text>
              </View>
              <Text
                style={{
                  fontSize: 12,
                  lineHeight: 14,
                  color: 'black',
                  fontFamily: 'TCCC-UnityText Bold',
                  alignSelf: 'center',
                  marginTop: 60,
                }}>
                Grupos de produtos
              </Text>
              <Text
                style={{
                  fontSize: 12,
                  lineHeight: 14,
                  color: Colors.GrayPallete.lightgrayThree,
                  fontFamily: 'TCCC-UnityHeadline Regular',
                  alignSelf: 'center',
                  textAlign: 'center',
                  maxWidth: 280,
                  marginTop: 20,
                }}>
                Abaixo veja os grupos e os produtos que você precisa comprar
                pelo menos uma caixa de cada grupo para cumprir essa missão.
              </Text>
              <View
                style={{
                  marginTop: 60,
                }}>
                <DropDownMenu
                  onPress={() => null}
                  title="Kit 1 de produtos"
                  fontSize={12}
                />
                <DropDownMenu
                  onPress={() => null}
                  title="Kit 2 de produtos"
                  fontSize={12}
                />
                <DropDownMenu
                  onPress={() => null}
                  title="Kit 3 de produtos"
                  fontSize={12}
                />
                <DropDownMenu
                  onPress={() => null}
                  title="Kit 4 de produtos"
                  fontSize={12}
                />
              </View>
            </View>
          </ScrollView>
        </View>
      </View>
    </Modal>
  );
};

export default IndicatorDetails;
